// StyleBase_style.js
export const cssVariables = {
  '--primary': '#7D7098',
  '--primary-dark': '#301B4B',
  '--secondary': '#9097C0',
  '--tertiary': '#A7BBEC',
  '--primary-accent': '#C19BD1',
  '--secondary-accent': '#6B5B95',
  '--mystical-glow': '#9B7EDE',
  '--shadow': '#1A0D2E',
  '--grey': '#333',
  '--dark-grey': '#4A4A4A'
};

// Function to apply CSS variables to document root
export const applyCSSVariables = () => {
  Object.entries(cssVariables).forEach(([key, value]) => {
    document.documentElement.style.setProperty(key, value);
  });
};

// Color helper functions
export const getColor = (colorName) => {
  const colorMap = {
    primary: '#7D7098',
    primaryDark: '#301B4B',
    secondary: '#9097C0',
    tertiary: '#A7BBEC',
    primaryAccent: '#C19BD1',
    secondaryAccent: '#6B5B95',
    mysticalGlow: '#9B7EDE',
    shadow: '#1A0D2E',
    grey: '#333',
    darkGrey: '#4A4A4A'
  };
  return colorMap[colorName] || colorName;
};